import {
    SessionContextDocument,
    SessionContextInput,
    SessionContextQuery,
    useUpdateSessionContextMutation,
} from 'gql/__generated/vp-apollo';
import { useCallback } from 'react';
import { useErrorHandling } from './useErrorHandling';

export const useUpdateSessionContext = () => {
    const { error, handleError, resetError } = useErrorHandling();

    const [mutate, { data, loading }] = useUpdateSessionContextMutation({
        onError(error) {
            handleError(error);
        },
        update(cache, { data }) {
            const newSessionContext = data?.updateSessionContext;

            if (newSessionContext) {
                cache.writeQuery<SessionContextQuery>({
                    query: SessionContextDocument,
                    data: {
                        sessionContext: newSessionContext,
                    },
                });
            }
        },
    });

    const updateSessionContext = useCallback(
        (fieldsToUpdate: SessionContextInput) => {
            resetError();
            return mutate({
                variables: {
                    input: fieldsToUpdate,
                },
            });
        },
        [mutate, resetError]
    );

    return {
        updateSessionContext,
        sessionContext: data?.updateSessionContext || null,
        loading,
        error,
    };
};
